<template>
  <div>
    <div class="swiper-item">
      <div class="swiper-body">
        <div class="swiper-title">提供有竞争力的解决方案和服务持续为客户创造高价值</div>
        <div class="swiper-line"></div>
        <div class="more" @click="phoneActive = !phoneActive">
          <img src="../../../static/images/home_button@2x.png" />
          <span>查看更多</span>
          <div class="phone" @click.stop v-show="phoneActive">0755-13278672 </div>
        </div>
      </div>
      <figure class="swiper-bg"></figure>
    </div>
    <div class="body">
      <img class="body-poster" :src="bodyImg" />
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {
        phoneActive: false,
        cases: [{
          id: 1,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case1_details%402x.png',
          title: '亚太分销系统'
        }, {
          id: 2,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case2_details%402x.png',
          title: '亚太理赔系统'
        }, {
          id: 3,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case3_details%402x.png',
          title: '智能查勘平台'
        }, {
          id: 4,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case4_details%402x.png',
          title: '智慧怡锦微门户'
        }, {
          id: 5,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case5_details%402x.png',
          title: '智慧台账系统'
        }, {
          id: 6,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case6_details%402x.png',
          title: '智税学院小程序'
        }, {
          id: 7,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case7_details%402x.png',
          title: '智税云小程序'
        }, {
          id: 8,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case8_details%402x.png',
          title: '多彩旅游圈小程序'
        }, {
          id: 9,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case9_details%402x.png',
          title: '西九华山景区'
        }, {
          id: 10,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case10_details%402x.png',
          title: '智慧中医小程序'
        }, {
          id: 11,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case11_details%402x.png',
          title: '智慧中医管理平台'
        }, {
          id: 12,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case12_details%402x.png',
          title: '财务自动归档平台'
        }, {
          id: 13,
          poster: 'https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case13_details%402x.png',
          title: '宝贝星球小程序'
        }]
      }
    },
    computed: {
      bodyImg () {
        const id = Number(this.$route.query.id)
        return this.cases.find(item => item.id === id).poster
      }
    }
  }
</script>
<style scoped>
.swiper-item {
  color: #ffffff;
  height: 560px;
  overflow: hidden;
  position: relative;
}
.swiper-body {
  max-width: 1200px;
  margin: 180px auto 0;
  font-size: 20px;
}
.swiper-title {
  font-size: 2em;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(250,250,250,1);
  font-weight:bold;
  width: 560px;
  line-height: 70px;
}
.swiper-line {
  width:40px;
  height:1px;
  background:rgba(255,255,255,1);
  margin-top: 14px;
}
.swiper-bg {
  width: 1920px;
  height: 560px;
  background-size: 1920px 560px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
  background-image: url('https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/case_h560px_banner%402x.png');
}
.more {
  width:176px;
  height:48px;
  background:rgba(255,87,78,1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size:18px;
  color:rgba(255,255,255,1);
  margin: 40px 0 0 0;
  cursor: pointer;
  position: relative;
}
.more:hover {
  background:#dc170d;
}
.more img {
  width: 24px;
  height: 24px;
  transform: translateY(1px);
  margin-right: 8px;
}
.phone {
  background-image: url('../../../static/images/case_h48_popup@2x.png');
  background-size: 100% 100%;
  position: absolute;
  right: -190px;
  top: 0;
  width: 176px;
  height: 48px;
  font-size:16px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(255,87,78,1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.body {
  background-color: #F7FCFC;
  overflow: hidden;
}
.body-poster {
  width: 1920px;
  position: relative;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 1199px) and (min-width: 992px){
  .swiper-body {
    padding: 0 50px;
  }
  .body-poster {
    width: calc(1920px * 0.82);
  }
}
@media (max-width: 991px) and (min-width: 768px){
  .swiper-body {
    padding: 0 50px;
  }
  .body-poster {
    width: calc(1920px * 0.70);
  }
}
@media screen and (max-width: 767px){
  .swiper-body {
    padding: 0 50px;
  }
  .body-poster {
    width: calc(1920px * 0.60);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/case/detail.vue